import React from "react";
import UseContext from "hooks/useContext";
import { TEMPLATE_STEPS_COUNT } from "pages/missionTemplates/templateSteps";

const TemplateIndicator = ({ formIndex }) => {
    const { language } = UseContext();
    const currentStep = formIndex;
    const progressPercent = Math.min(
        100,
        Math.max(0, (currentStep / TEMPLATE_STEPS_COUNT) * 100)
    );
    return (
        <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="flex-1 min-w-0">
                <div className="mb-1.5">
                    <span className="text-sm font-medium text-gray-700">
                        {language
                            .getValue(
                                "missionTemplate.wizard.stepCount",
                                "Étape {current} sur {total}"
                            )
                            .replace("{current}", currentStep)
                            .replace("{total}", TEMPLATE_STEPS_COUNT)}
                    </span>
                </div>
                <div className="h-2 w-full max-w-xs bg-gray-100 rounded-full overflow-hidden">
                    {/* Inline width: Tailwind cannot generate a class computed at runtime. */}
                    <div
                        className="bg-gradient-to-r from-yellow-400 to-yellow-500 h-full rounded-full transition-all duration-300 ease-out"
                        style={{ width: `${progressPercent}%` }}
                    />
                </div>
            </div>
        </div>
    );
};

export default TemplateIndicator;
